import types from '../mutation-types'

const state = {
  pageTitle: null,
  createButton: {
    display: false,
    text: null,
    to: null
  },
  actualFund: null,
  actualReel: null
}

const mutations = {
  [types.SET_HEADER_STATE] (state, data) {
    state.pageTitle = data.pageTitle
    state.createButton = data.createButton
  },

  [types.SET_ACTUAL_FUND] (state, data) {
    state.actualFund = data
  },

  [types.SET_ACTUAL_REEL] (state, data) {
    state.actualReel = data
  }
}

const actions = {}

const getters = {}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js